export const validateName = (name) => {
  const nameRegex = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;
  if (!name) {
    return "Name is required";
  } else if (name.length < 2) {
    return "Name must be at least 2 characters long";
  } else if (!nameRegex.test(name)) {
    return "Name can only contain letters and spaces, with no spaces at the beginning or end, and no consecutive spaces";
  }
  return "";
};

export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!email) {
    return "Email is required";
  } else if (email.length < 2) {
    return "Email must be at least 2 characters long";
  } else if (!emailRegex.test(email)) {
    return "Enter a valid Email Address";
  }
  return "";
};
